import { useContext } from "react";
import { MerchantContext } from "./MerchantProvider";

export default function useMerchantContext() {
    return useContext(MerchantContext);
};
